import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';

interface KPICardsProps {
  totalCheckins: number;
  totalFinalizados: number;
  totalCancelados: number;
  emFila: number;
}

export const KPICards: React.FC<KPICardsProps> = ({
  totalCheckins,
  totalFinalizados,
  totalCancelados,
  emFila,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2, borderTop: '4px solid #1976d2' }} elevation={3}>
          <Typography variant="subtitle2">Total de Check-ins</Typography>
          <Typography variant="h4">{totalCheckins}</Typography>
          <Typography variant="caption">Últimos 24h</Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2, borderTop: '4px solid #2e7d32' }} elevation={3}>
          <Typography variant="subtitle2">Finalizados</Typography>
          <Typography variant="h4">{totalFinalizados}</Typography>
          <Typography variant="caption">
            {((totalFinalizados / totalCheckins) * 100).toFixed(1)}% de sucesso
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2, borderTop: '4px solid #d32f2f' }} elevation={3}>
          <Typography variant="subtitle2">Cancelados</Typography>
          <Typography variant="h4">{totalCancelados}</Typography>
          <Typography variant="caption">
            {((totalCancelados / totalCheckins) * 100).toFixed(1)}%
          </Typography>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Paper sx={{ p: 2, borderTop: '4px solid #ed6c02' }} elevation={3}>
          <Typography variant="subtitle2">Em Fila</Typography>
          <Typography variant="h4">{emFila}</Typography>
          <Typography variant="caption">Aguardando processamento</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};
